import { BaseModel } from '../../../../../../core/_base/crud';
    export class KeHoachHangVe extends BaseModel {
       
        Id: number;
        NgayDeNghiGiaoHang: string;
        HangHoaId: number;
        MaHang: string;
        TenHang: string;
        QuyCach: string;
        DVT: number;
        TenDVT: string;
        SoLuong: string;
        LoaiHH: number;
        TenLoaiHH: string;
        IdNCC: number;
        MaNCC: string;
        TenNCC: string;
        GhiChu: string;
        IdPDH: number;
        SoPhieuDH: string;
        IdPB: number;
        TenPB: string;
        SoPhieuDNMH:string;
        //bổ sung
	NguoiNhanHang:string
        clear() {
            this.Id = 0;
            this.NgayDeNghiGiaoHang = '';
            this.HangHoaId= 0;
            this.MaHang= '';
            this.TenHang= '';
            this.QuyCach= '';
            this.DVT= 0;
            this.TenDVT= '';
            this.SoLuong= '';
            this.LoaiHH= 0;
            this.TenLoaiHH= '';
            this.IdNCC= 0;
            this.MaNCC= '';
            this.TenNCC= '';
            this.GhiChu= '';
            this.IdPDH = 0;
            this.SoPhieuDH = '';
            this.IdPB = 0;
            this.TenPB = '';
            this.NguoiNhanHang='';
        }
        copy(item:KeHoachHangVe){
            this.Id = item.Id;
            this.NgayDeNghiGiaoHang = item.NgayDeNghiGiaoHang;
            this.HangHoaId= item.HangHoaId;
            this.MaHang= item.MaHang;
            this.TenHang=item.TenHang;
            this.QuyCach= item.QuyCach;
            this.DVT= item.DVT;
            this.TenDVT= item.TenDVT;
            this.SoLuong= item.SoLuong;
            this.LoaiHH= item.LoaiHH;
            this.TenLoaiHH= item.TenLoaiHH;
            this.IdNCC= item.IdNCC;
            this.MaNCC= item.MaNCC;
            this.TenNCC= item.TenNCC;
            this.GhiChu= item.GhiChu;
            this.IdPDH = item.IdPDH;
            this.SoPhieuDH = item.SoPhieuDH;
            this.IdPB = item.IdPB;
            this.TenPB = item.TenPB;
            this.NguoiNhanHang=item.NguoiNhanHang;
        }
    }

    export class FileDinhKem extends BaseModel{

        IdFile: number;
        FileName: string;
        GhiChu: string;

        clear(){
            this.IdFile = 0;
            this.FileName = '';
            this.GhiChu = '';
        }
    }

    export class DSFileImport extends BaseModel{
        listImport: FileImport[];

        clear(){
            this.listImport = [];
        }
    }

    export class FileImport extends BaseModel{
        idLoaiHH: number;
        base64: string;
        fileByte: any;
        filename: string;
        dienGiai: string;
        extension: string;

        clear(){
            this.idLoaiHH = 0;
            this.base64= '';
            this.fileByte= null;
            this.filename= '';
            this.dienGiai= '';
            this.extension= '';
        }

        copy(item: FileImport){
            this.idLoaiHH = item.idLoaiHH;
            this.base64= item.base64;
            this.fileByte= item.fileByte;
            this.filename= item.filename;
            this.dienGiai= item.dienGiai;
            this.extension= item.extension;
        }
    }

